export default __webpack_public_path__ + "static/media/service-christmas.75ebcbdc.webp";